import axios, { AxiosResponse } from "axios";
import { Usuario } from "../interfaces/UsuarioSearch";
import { IDatosRespuesta } from "../interfaces/RespuestaDTO";
import { Guardaruser, UsuarioRol } from "../interfaces/UsuariosRoles";
import { ResponceApi } from "../interfaces/Responses";
import { RolesInvUnidadDTO } from "../interfaces/Usuarios/RolPersonaUnidadDTO";
import { PersonaInvDTO, VoidPersonaInvDTO } from "../interfaces/Usuarios/PersonaInvDTO";
const localBack : string = process.env.REACT_APP_BACK || ''; 
const APICATALOGO : string = '/api/Usuario';

export default class UsuarioService{
  
    //Nuevo
    async GetUsuarioByEmail(token: any, email: string): Promise<ResponceApi<PersonaInvDTO>>{
      const response1:AxiosResponse<ResponceApi<PersonaInvDTO>> = await axios.get(localBack+APICATALOGO+'/GetUserByEmail/'+email,
      {
          headers: {
            Authorization: `Bearer ${token}`
          }
      });
      return response1.data;
    }
    async GetUserByIdentificacion(token: any, cedula: string): Promise<ResponceApi<PersonaInvDTO>>{
      const response1:AxiosResponse<ResponceApi<PersonaInvDTO>> = await axios.get(localBack+APICATALOGO+'/GetUserByIdentificacion/'+cedula,
      {
          headers: {
            Authorization: `Bearer ${token}`
          }
      });
      return response1.data;
    }
    //Obsoleto actualizar
    async GetListUsuarios(token:any): Promise<ResponceApi<PersonaInvDTO>> {
        const response1:AxiosResponse<ResponceApi<PersonaInvDTO>> = await axios.get(localBack+APICATALOGO+'/ListUsuarios',
        {
            headers: {
              Authorization: `Bearer ${token}`
            }
        });
        //console.log(response1.data);        
        return response1.data;
    }

    async GetUsuariosCreados(token: any, user: string): Promise<ResponceApi<PersonaInvDTO>>{
        const response1:AxiosResponse<ResponceApi<PersonaInvDTO>> = await axios.get(localBack+APICATALOGO+'/ShowsAllUsers/'+user,
        {
            headers: {
              Authorization: `Bearer ${token}`
            }
        });
        //console.log(response1.data);        
        return response1.data;
    }

    async GuardarUsuarioNuevo(userNew: PersonaInvDTO,token:any):Promise<ResponceApi<PersonaInvDTO>>{
        try {
              const response: AxiosResponse<ResponceApi<PersonaInvDTO>> = await axios.post(
                localBack + APICATALOGO + '/PostRolesUsuario',
              userNew,
                {
                  headers: {
                      Authorization: `Bearer ${token}`,
                  },
                }
              );            
              if (response.data) {
                  //console.log(response.data)
                  return response.data;
              } else {
                  throw new Error('No se recibieron datos válidos.');
              }
            } catch (error) {
              console.error('Error al enviar la solicitud:', error);
              throw error; // Re-lanzar el error para que se maneje donde se llama a la función
            }
    }
    async PostRolesUsuario(userNew: PersonaInvDTO,token:any):Promise<ResponceApi<PersonaInvDTO>>{
      try {
            const response: AxiosResponse<ResponceApi<PersonaInvDTO>> = await axios.post(
              localBack + APICATALOGO + '/PostRolesUsuario',
            userNew,
              {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
              }
            );            
            if (response.data) {
                //console.log(response.data)
                return response.data;
            } else {
                throw new Error('No se recibieron datos válidos.');
            }
          } catch (error) {
            console.error('Error al enviar la solicitud:', error);
            return {
              status: { isSuccessfully: false, messages: ['Error al enviar al guardar el producto'] },
              operation: 0,
              statusCode: 500,
              count: 0,
              listData: [],
              data: VoidPersonaInvDTO(),
            }
          }
  }
    async GetUsuarioById(token: any, idUser: number | undefined): Promise<ResponceApi<PersonaInvDTO>>{
      const response1:AxiosResponse<ResponceApi<PersonaInvDTO>> = await axios.get(localBack+APICATALOGO+'/GetUserById/'+idUser,
      {
          headers: {
            Authorization: `Bearer ${token}`
          }
      });
      return response1.data;
    }

    async ActualizarUsuarioById(token: any, usuario: PersonaInvDTO): Promise<ResponceApi<PersonaInvDTO>>{
      try {
        const response: AxiosResponse<ResponceApi<PersonaInvDTO>> = await axios.put(
          localBack + APICATALOGO + '/UpdateRolesUsuario/'+usuario.iddecinvuser,
        usuario,
          {
            headers: {
                Authorization: `Bearer ${token}`,
            },
          }
        );            
        if (response.data) {
            //console.log(response.data)
            return response.data;
        } else {
            throw new Error('No se recibieron datos válidos.');
        }
      } catch (error) {
        console.error('Error al enviar la solicitud:', error);
        throw error; // Re-lanzar el error para que se maneje donde se llama a la función
      }
    }

    async ElminarUsuarioById(token: any, iduser: number) : Promise<IDatosRespuesta<Guardaruser>>{
      try{
        const response: AxiosResponse<IDatosRespuesta<Guardaruser>> = await axios.delete(
          localBack + APICATALOGO + '/DeleteUsuario/'+iduser,
          {
            headers:{
              Authorization: `Bearer ${token}`
            }
          }
        )
        if (response.data) {
          //console.log(response.data)
          return response.data;
        } else {
            throw new Error('No se recibieron datos válidos.');
        }

      }catch(error){
        console.error('Error al enviar la solicitud:', error)
        throw error;
      }
    }

    async GetScopusID(orcid: string): Promise<any>{
      try{
        const response1:AxiosResponse<any> = await axios.get('https://api.elsevier.com/content/search/author?query=orcid('+orcid+')&apiKey=d2f270ed229df1d1aa750351fa2c101b',
        {
            headers: {
              Accept: 'application/json'
            }
        });

        if(response1){
          return response1;
        }else{
          throw new Error('No se recibieron datos válidos.');
        }

      }catch(error){
        console.error('Error en el servidor', error)
      }
      
    }

    authorized(roles:Array<RolesInvUnidadDTO>):boolean{
      if(roles.length === 0){
        return false;
      }else{
          return true;
      }
    }

    //Los numeros usados en esta función deben estar presentes en la tabla de Saf3 TBL_ROL CON SISTEMA 41
    authorizedByRol(rol:number,roles:Array<RolesInvUnidadDTO>):boolean{
      if(roles.filter(x=> x.idrol === rol).length > 0){
        return true;
      }else{
        return false;
      }
    }

    tieneCoincidencia(lista1: string[], lista2: string[]): boolean {
      // Utiliza el método some() para verificar si al menos un elemento de lista1 está presente en lista2
      return lista1.some(item => lista2.includes(item));
    }

    authorizedByGroup(rolesConAcceso:Array<number>,rolesUsuario:Array<any>):boolean{
      let tieneAcceso = false;
      tieneAcceso = rolesUsuario.some(rolUsuario =>
        rolesConAcceso.includes(rolUsuario.idrol)
      );
      return tieneAcceso;
    }

}